import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardImg,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";

const baseurl = process.env.REACT_APP_BASE_URL;
const imgurl = process.env.REACT_APP_IMAGE_URL;

const MediaModel = ({
  imageModel,
  toggleModal,
  handleUploadImage,
  selectedImage,
  setSelectedImage,
  modalType,
}) => {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);

  const fetchFiles = async () => {
    try {
      setError(null);
      const response = await fetch(`${baseurl}/admin/media`);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setFiles(data);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const Images = files.filter((file) => file.mimetype?.startsWith("image/"));
  const Datasheets = files.filter((file) => file.mimetype === "application/pdf");
  const filesToDisplay = modalType === "datasheet" ? Datasheets : Images;

  const isSelected = (file) =>
    modalType === "other"
      ? selectedImage?.some((i) => i.id === file.id)
      : selectedImage?.[0]?.id === file.id;

  const handleSelectFile = (file) => {
    if (modalType === "other") {
      const exists = selectedImage?.find((i) => i.id === file.id);
      if (exists) {
        setSelectedImage(selectedImage.filter((i) => i.id !== file.id));
      } else {
        if ((selectedImage?.length || 0) < 5) {
          setSelectedImage([...(selectedImage || []), file]);
        } else {
          alert("You can select up to 5 images only.");
        }
      }
    } else {
      setSelectedImage([file]);
    }
  };

  return (
    <Modal
      isOpen={imageModel}
      toggle={toggleModal}
      backdrop="static"
      keyboard={false}
      size="xl"
      scrollable={true}
      centered={true}
      style={{ maxHeight: "100vh", maxWidth: "90%" }}
    >
      <ModalHeader toggle={toggleModal} tag="h4">
        Select {modalType === "datasheet" ? "Datasheet" : "Image"}
        {modalType === "other" ? "s" : ""}
      </ModalHeader>

      <ModalBody style={{ height: "100vh", overflow: "hidden" }}>
        <Row style={{ height: "100%" }}>
          <Col lg={9} style={{
    height: "65vh",
    overflowY: "auto",
    borderRight: "1px solid #e9ebec",
    paddingRight: "10px"
  }}>
            <div className="media-box d-flex flex-wrap gap-3">
              {filesToDisplay?.map((file) => (
                <Card
                  key={file.id}
                  style={{
                    position: "relative",
                    width: "150px",
                    border: isSelected(file) ? "2px solid #74788d" : "1px solid #e9ebec",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSelectFile(file)}
                  className="mb-0 p-2"
                >
                  <div className="img-media">
                    {modalType === "datasheet" ? (
                      <div className="datasheet-preview text-center">
                        <i
                          className={`mdi ${
                            file.mimetype === "application/pdf"
                              ? "mdi-file-pdf"
                              : "mdi-file-document"
                          }`}
                          style={{ fontSize: "50px", color: "#dc3545" }}
                        />
                        <p className="small text-truncate mt-2">{file.filename}</p>
                      </div>
                    ) : (
                      <CardImg
                        src={`${imgurl}${file.fileurl}`}
                        alt={file.filename}
                        style={{ height: "100px", objectFit: "cover", borderRadius: "4px" }}
                      />
                    )}

                    {isSelected(file) && (
                      <i
                        className="bx bx-check"
                        style={{
                          position: "absolute",
                          top: "-10px",
                          right: "-10px",
                          fontSize: "24px",
                          zIndex: 10,
                          backgroundColor: "#74788d",
                          color: "#fff",
                          borderRadius: "50%",
                          padding: "2px",
                        }}
                      ></i>
                    )}
                  </div>
                </Card>
              ))}
            </div>
          </Col>

          <Col lg={3} >
            {selectedImage?.length > 0 && (
              <div
                className="selected-image-details"
                style={{
    height: "65vh",
    overflowY: "auto",
    borderRight: "1px solid #e9ebec",
    paddingRight: "10px"
  }}
              >
                <h6 className="text-center mb-2">ATTACHMENT DETAILS</h6>
                {selectedImage.map((file) => (
                  <div
                    key={file.id}
                    className="mb-3"
                    style={{
                      border: "1px solid rgb(233, 235, 236)",
                      padding: "8px",
                      borderRadius: "4px",
                      backgroundColor: "#fff",
                    }}
                  >
                    {modalType === "datasheet" ? (
                      <>
                        <i
                          className={`d-flex align-items-center justify-content-center mb-3 mdi ${
                            file.mimetype === "application/pdf"
                              ? "mdi-file-pdf"
                              : "mdi-file-document"
                          }`}
                          style={{ fontSize: "70px", color: "#dc3545" }}
                        />
                        <p><strong>Title:</strong> {file.title}</p>
                        <p><strong>Caption:</strong> {file.caption}</p>
                        <p><strong>Description:</strong> {file.description}</p>
                        <p><strong>File Name:</strong> {file.filename}</p>
                        <p><strong>File Type:</strong> {file.mimetype}</p>
                        <p className="mb-0">
                          <strong>File URL:</strong>{" "}
                          <a
                            href={`${imgurl}${file.fileurl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {file.fileurl.split("/").pop()}
                          </a>
                        </p>
                      </>
                    ) : (
                      <>
                        <img
                          src={`${imgurl}${file.fileurl}`}
                          alt="Selected"
                          className="mb-3"
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "5px",
                            objectFit: "cover",
                          }}
                        />
                        <p><strong>Title:</strong> {file.title}</p>
                        <p><strong>Caption:</strong> {file.caption}</p>
                        <p><strong>Description:</strong> {file.description}</p>
                        <p><strong>Uploaded on:</strong> {file.uploaded_on}</p>
                        <p><strong>File Name:</strong> {file.filename}</p>
                        <p><strong>File Type:</strong> {file.mimetype}</p>
                        <p><strong>File Size:</strong> {Math.round(file.filesize / 1024)} KB</p>
                        <p><strong>Dimensions:</strong> 275 x 275</p>
                        <p className="mb-0">
                          <strong>File URL:</strong>{" "}
                          <a
                            href={`${imgurl}${file.fileurl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {file.fileurl.split("/").pop()}
                          </a>
                        </p>
                      </>
                    )}
                  </div>
                ))}
              </div>
            )}
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter  style={{ position: "sticky", bottom: 0, background: "#fff" }}>
        <Button
          onClick={() => {
            if (selectedImage?.length > 0) {
              handleUploadImage(selectedImage);
            }
          }}
        >
          Upload
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MediaModel;
